@use '../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .styledChartTooltip {
    padding: 12px 0;

    [data-chart-tooltip-title] {
      padding: 0 12px;
    }
  }

  .itemsContainer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 12px;
  }

  .coloredValue {
    @include typography-v2-body-xs;
  }

  .coloredValuePositive {
    color: var(--viz-bullish);
  }

  .coloredValueNegative {
    color: var(--viz-bearish);
  }

  .coloredValueNeutral {
    color: var(--text-default);
  }

  .separator {
    margin: 5px 0;
    border-bottom: 1px dashed var(--border-default);
  }
}
